export default "__VITE_ASSET__D88Qlo1p__"